// Capability helpers for vehicles displayed in inquiry forms.

/**
 * Liefert true, wenn das gewählte Kühlfahrzeug NUR Frischware kann (kein Tiefkühl).
 * Aktuell trifft das nur auf den Mercedes Vito Kühlkastenwagen zu
 * (Temperaturbereich 0 °C bis +7 °C).
 */
export function isFreshOnlyCoolingVehicle(label?: string | null): boolean {
  if (!label) return false;
  return /vito/i.test(label);
}
